import React from "react";
import { Helmet } from "react-helmet";
import { SEOConfig } from "../../config/seo-configure";

interface SEOComponentProps {
  title?: string;
  description?: string;
  image?: string;
}

const SEOComponent: React.FC<SEOComponentProps> = ({
  title,
  description,
  image,
}: SEOComponentProps) => {
  const seoTitle = title ? `${SEOConfig.title} / ${title}` : SEOConfig.title;
  const seoDescription = description ? description : SEOConfig.description;
  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />

      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:type" content="website" />

      <meta property="twitter:title" content={seoTitle} />
      <meta property="twitter:description" content={seoDescription} />
      <meta property="twitter:card" content="summary_large_image" />

      {image && <meta property="og:image" content={image} />}

      {image && <meta property="twitter:image" content={image} />}
    </Helmet>
  );
};

export const SEO = React.memo(SEOComponent);
